import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export const AnimatedSection = ({ 
  children, 
  animation = 'fade-zoom',
  delay = 0,
  className = '',
  ...props 
}) => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });

  const animationClass = {
    'fade-zoom': 'animate-fade-zoom',
    'slide-up-bounce': 'animate-slide-up-bounce',
    'slide-right-strong': 'animate-slide-right-strong',
    'slide-left-strong': 'animate-slide-left-strong',
    'rotate-scale': 'animate-rotate-scale',
    'flip-in': 'animate-flip-in',
    'elastic-scale': 'animate-elastic-scale',
  }[animation];

  return (
    <div
      ref={ref}
      className={`scroll-animate ${isVisible ? `visible ${animationClass}` : ''} ${className}`}
      style={{ 
        animationDelay: `${delay}s`,
        animationFillMode: 'both'
      }}
      {...props}
    >
      {children}
    </div>
  );
};
